module.exports = __webpack_public_path__ + "assets/img/track-bottom-text-light-en.7703e69d.png";